import React from 'react';
import ImageUpload from '@/components/ui/custom/input/ImageUpload';
import CoursePath from '@/models/CoursePath';
import { heading2 } from '@/styles/styles';
import { useController, useFormContext } from 'react-hook-form';
import { twJoin } from 'tailwind-merge';
import CourseHeaderActions from '../actions/CourseBoxActions';
import CourseStatus from '../CourseStatus';
import TitleForm from '../TitleForm';
import { CourseHeaderFields } from './CourseBoxHeaderForm';

type CourseBoxHeaderCollapsedProps = {
  coursePath: CoursePath;
  isLoading?: boolean;
};

const CourseBoxHeaderCollapsed = React.memo(function CourseBoxHeaderCollapsed({
  coursePath,
}: CourseBoxHeaderCollapsedProps) {
  const { control } = useFormContext<CourseHeaderFields>();

  const { field } = useController({
    control,
    name: 'course.bannerImg',
  });

  return (
    <div className="flex gap-2.5 justify-between w-full">
      <section className="flex gap-2.5 items-center">
        <ImageUpload
          readonly
          accept=".jpg,.jpeg,.png,.gif,.webp"
          value={field.value || '/images/course-default-image.png'}
          onChange={field.onChange}
          className={{
            div: 'w-[5rem]',
            base: 'w-fit',
            img: 'rounded-lg aspect-video object-cover',
          }}
        />
        <TitleForm
          control={control}
          fieldName="course.name"
          maxLength={200}
          className={{
            span: twJoin(
              heading2,
              'text-primary !font-poppins truncate lg:max-w-[350px] xl:max-w-[600px]',
            ),
            icon: 'w-5 h-5',
          }}
        />
      </section>
      <div className="flex gap-2.5 items-center w-full flex-wrap justify-end">
        <CourseHeaderActions coursePath={coursePath} />
        <CourseStatus status={coursePath.status} version={coursePath.version} />
      </div>
    </div>
  );
});

export default CourseBoxHeaderCollapsed;
